import React, { useContext, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { TrailContext } from './TrailContext';
import Hamburger from '../images/menu.svg';
import CloseIcon from '../images/icons8-close-window.svg';
import '../CSS/Nav.css';

function NavBar(props) {

    const [trails] = useContext(TrailContext);
    const linkStyle = { color: 'white', textDecoration: 'none' };
    const otherLinkStyle = { color: 'black', textDecoration: 'none' };

    const [isNavOpen, setIsNavOpen] = useState(false);
    const ref = useRef();

    function clickOutside(ref,) {

        setTimeout(() => {
            function listener (event) {
                if(!ref.current || ref.current.contains(event.target)) {
                    return
                };
                setIsNavOpen(false);
                console.log('hello');
                window.removeEventListener('click', listener);
            }
            
            window.addEventListener('click', listener);
        }, 50)
        
    }

    function onToggle() {
        setIsNavOpen(!isNavOpen);
        clickOutside(ref)
    }

    return(
        <div>
            <nav className="navBar">
                <Link to='/' className="navItem homeLink" style={linkStyle}>Home</Link>
                <button onClick={onToggle} className="toggle"><img src={Hamburger} alt="menu icon" draggable="false"/></button>                
            </nav>
            <div ref={ref} className={`slideOut ${isNavOpen ? 'open' : 'closed'}`}>
                <button onClick={() => setIsNavOpen(!isNavOpen)} className="close"><img src={CloseIcon} alt="close menu" draggable="false"/></button>
                <ul className="slideOut__Links">
                    <li><Link to="/" className="navItem" style={otherLinkStyle}>Home</Link></li>
                    <li><Link to="/etiquete" style={otherLinkStyle} className="navItem">Trail Ettiquete</Link></li>
                    <li><Link to="/trails" style={otherLinkStyle} className="navItem">All Trails</Link></li>
                    <li></li>
                    {trails.map(trail => (
                        <li key={trail.name}><Link to={`/trails/${trail.url}`} style={otherLinkStyle} className={`navItem`}>{trail.name}</Link></li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default NavBar;